module.exports = __webpack_public_path__ + "img/kniupa.b581fac0.png";